import React, { ReactElement, useContext, useEffect, useState } from 'react';
import defaultStyle from './index.module.scss';
import soyRappiLogo from '../../../assets/soy-rappi-logo.png';
import { perfilSatContext } from '../../../context/perfil.sat.context';
import OtpComponent from '../../molecules/otp-component';
import Back from '../../../assets/arrow-back-black.svg';
import ErrorTooltip from '../../molecules/error-tooltip';
import MxFlag from '../../../assets/MX.svg';
import { useNavigate } from 'react-router-dom';

interface Props {
  goBackLanding?: () => void;
}

const Login = ({ goBackLanding }: Props): ReactElement => {
  const {
    inputLogin,
    setInputLogin,
    Login,
    setShowOtp,
    showOtp,
    errorMessages
  } = useContext(perfilSatContext);

  const browse = useNavigate();
  const [error, setError] = useState<string>('');
  const [closeTooltip, setCloseTooltip] = useState<boolean>(false);
  const [isEmail, setIsEmail] = useState<boolean>(false);
  const [isPhoneNumber, setIsPhoneNumber] = useState<boolean>(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneNumberRegex = /^\d{1,10}$/;
  const validateOnlyNumbers = /^[0-9\b]+$/;

  const handleInputLogin = (e: any) => {
    const value = e.target.value;

    if (value.length > 2) {
      const validateEmail = emailRegex.test(value);
      const validateNumber = validateOnlyNumbers.test(value);
      if (validateEmail) {
        setIsEmail(true);
        setIsPhoneNumber(false);
        setInputLogin(value);
      } else if (validateNumber) {
        setIsPhoneNumber(true);
        setIsEmail(false);
        if (value.length > 10) {
          return;
        } else {
          setInputLogin(value);
        }
      } else {
        setIsEmail(false);
        setIsPhoneNumber(false);
        setInputLogin(value);
      }
    } else {
      setIsEmail(false);
      setIsPhoneNumber(false);
      setInputLogin(value);
    }
  };

  const onChangeOtp = () => {
    Login(inputLogin);
  };
  const goBack = () => {
    setShowOtp(false);
    setInputLogin('');
  };

  const showFlagInInput = () => {
    if (
      inputLogin.length > 0 &&
      phoneNumberRegex.test(inputLogin) &&
      !emailRegex.test(inputLogin)
    ) {
      return (
        <div className={defaultStyle.flagContainer}>
          <div className={defaultStyle.flagContent}>
            <img
              src={MxFlag}
              alt={'MxFlag'}
              className={defaultStyle.flag}
            />
          </div>
          <div className={defaultStyle.mxNumber}>+52</div>
        </div>
      );
    } else {
      return <></>;
    }
  };

  const paddingInput = () =>
    inputLogin.length > 0 &&
    phoneNumberRegex.test(inputLogin) &&
    !emailRegex.test(inputLogin)
      ? '80px'
      : '20px';

  const errorValidation = () => {
    if (inputLogin.length === 0) {
      setError('');
    }
    if (isPhoneNumber && inputLogin.length < 10) {
      setError('El número ingresado no es válido');
    } else if (!isEmail && !isPhoneNumber) {
      setError('El dato ingresado no es válido');
    } else {
      setError('');
    }
  };

  useEffect(() => {
    if (inputLogin.length > 0) {
      errorValidation();
    } else {
      setError('');
    }
  }, [inputLogin]);

  return (
    <>
      {showOtp ? (
        <OtpComponent
          inputLogin={inputLogin}
          goBack={goBack}
          setInputLogin={setInputLogin}
        />
      ) : (
        <div className={defaultStyle.container}>
          <div className={defaultStyle.headerContainer}>
            <div
              className={defaultStyle.backContainer}
              onClick={() => {
                browse('/');
              }}
            >
              <img
                src={Back}
                alt={'Back'}
                style={{
                  cursor: 'pointer',
                  marginLeft: '10px',
                  marginRight: '5px',
                  width: '24px',
                  height: '24px'
                }}
              />
              <div className={defaultStyle.backText}>Volver</div>
            </div>
            <img
              src={soyRappiLogo}
              alt={'soyRappiLogo'}
              className={defaultStyle.logoPosition}
            />
          </div>
          <div className={defaultStyle.border}></div>
          <>
            {errorMessages && !closeTooltip && (
              <ErrorTooltip
                errorMessages={errorMessages}
                setCloseTooltip={setCloseTooltip}
              />
            )}
          </>
          <div className={defaultStyle.loginContent}>
            <div className={defaultStyle.loginTitle}>
              Inicia sesión con tu numero de teléfono o tu correo electrónico de tu cuenta de <b>Soy Rappi </b>
            </div>
            <div className={defaultStyle.phoneInput}>
              {showFlagInInput()}
              <input
                type='text'
                placeholder='Teléfono o correo electrónico'
                value={inputLogin}
                onChange={handleInputLogin}
                onBlur={errorValidation}
                className={`${defaultStyle.emailInput} ${error ? 'error' : ''}`}
                style={{
                  borderColor: error ? 'red' : '#E6EBF1',
                  paddingLeft: paddingInput()
                }}
              />
            </div>
            {error && (
              <div className={defaultStyle.contentErrorLabel}>
                <p style={{ color: 'red' }} className={defaultStyle.errorLabel}>
                  {error}
                </p>
              </div>
            )}
            <button disabled={!isEmail && !isPhoneNumber} className={defaultStyle.button} onClick={onChangeOtp}>
              Continuar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
